import { prefixObjectValues } from '../../utils';
const costCalculator = {
  totalCostNoDiff: 'total-cost-no-diff',
  diffCost: 'diff-cost',
  totalCostWithDiff: 'total-cost-with-diff',
  row: 'row',
  shiftType: 'shift-type',
  count: 'count',
  rvus: 'rvus',
  hourlyRate: 'hourly-rate',
  pricePerRvu: 'price-per-rvu',
  hoursPerShift: 'hours-per-shift',
  costPerShift: 'cost-per-shift',
  subTotal: 'sub-total',
};
export default prefixObjectValues(costCalculator, 'cost-calculator');
